import { IDecorate } from './types';
import { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios';
import Config from '@/config';
import Default from './default';
import GCPService from './gcpService';
import BFFService from './bffService';

/*
 * HTTP Decoration class
 * For multiple backends, different config such as headers, different response structures, they are mapped to different decoration classes for processing
 * Default: Decorate Default
 */
let HTTP_DECORATE_REGISTER: { [key: string]: () => IDecorate } = {
  [Config.H5_SERVICE.URL]: () => new GCPService(),
  [`${Config.BFF_SERVICE.URL}/hainan-bff`]: () => new BFFService(),
  [`${Config.BFF_SERVICE.URL}/hainan-logger`]: () => new BFFService(),
};
{
  HTTP_DECORATE_REGISTER = { ...HTTP_DECORATE_REGISTER };
}

export default class HttpDecorate {
  Declare: IDecorate;
  register(url: string) {
    this.Declare = new Default();

    for (const key in HTTP_DECORATE_REGISTER) {
      if (url.startsWith(key)) {
        this.Declare = HTTP_DECORATE_REGISTER[key]();
        break;
      }
    }
  }

  /**
   * Add request flag to URL
   */
  private addRequestFlagToUrl(config: AxiosRequestConfig): void {
    const requestFlag = (config as any)?._requestFlag;
    if (requestFlag) {
      const [baseUrl, queryString] = config.url.split('?');

      // prepend _f as the first query parameter
      if (queryString) {
        config.url = `${baseUrl}?_f=${requestFlag}&${queryString}`;
      } else {
        config.url = `${baseUrl}?_f=${requestFlag}`;
      }

      // clean custom field from config
      delete (config as any)._requestFlag;
    }
  }

  async config(config: AxiosRequestConfig) {
    // add request flag to URL
    this.addRequestFlagToUrl(config);

    this.register(config.url);
    await this.Declare.config?.(config);
  }

  async success(
    result: AxiosResponse,
    request: (config: AxiosRequestConfig) => any,
  ) {
    return await this.Declare.success?.(result, request);
  }

  async error(err: AxiosError, request: (config: AxiosRequestConfig) => any) {
    return await this.Declare.error?.(err, request);
  }
}
